import React, { useEffect, useState } from "react";
import { Typography, FormControlLabel, TextField, FormLabel, RadioGroup, Radio, Grid } from '@mui/material';
import ModalFooter from "../../../Modal/ModalFooter/ModalFooter";

export default function StepOne(props) {
    const [buttons, setButtons] = useState(
        [
            {
                'function': props.prev,
                'text': 'Précedent',
                'disabled': false,
                'color': 'error'
            },
            {
                'function': props.next,
                'text': 'Suivant',
                'disabled': true,
                'color': 'success'
            }
        ]);

    useEffect(() => {
        if (props.datas.typeApart && Object.keys(props.datas.typeApart).length >= 4) {
            buttons[1].disabled = false;
        } else {
            buttons[1].disabled = true;
        }
        setButtons([...buttons]);
    }, [props.datas]);

    function handleChange(e) {
        let datas = Object.assign({}, props.datas);
        if (!datas.typeApart) {
            datas.typeApart = {};
        }
        datas.typeApart[e.target.name] = e.target.value;
        props.handleChange(datas);
    }

    return (
        <>
            <Typography id="modal-modal-description" variant="p">
                Quel type de logement proposez-vous ?
            </Typography>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container direction='row' alignItems='center' justifyContent='center'>
                        <Grid item xs={12} md={7}>
                            <FormLabel component="legend">Une ou plusieurs chambres situées à l’intérieur de ma résidence (appartement ou maison)</FormLabel>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <RadioGroup
                                row
                                defaultValue={props.datas.typeApart && props.datas.typeApart.chambres}
                                name="radio-buttons-group">
                                <FormControlLabel
                                    value="Zone urbaine"
                                    control={<Radio name='chambres'
                                        onChange={(e) => handleChange(e)} />}
                                    label="Zone urbaine" />
                                <FormControlLabel
                                    value="Zone rurale"
                                    control={<Radio name='chambres'
                                        onChange={(e) => handleChange(e)} />}
                                    label="Zone rurale" />
                                <FormControlLabel
                                    value="Sans objet"
                                    control={<Radio name='chambres'
                                        onChange={(e) => handleChange(e)} />}
                                    label="Sans objet" />
                            </RadioGroup>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container direction='row' alignItems='center' justifyContent='center'>
                        <Grid item xs={12} md={7}>
                            <FormLabel component="legend">L’intégralité de ma résidence principale (appartement ou maison)</FormLabel>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <RadioGroup
                                row
                                defaultValue={props.datas.typeApart && props.datas.typeApart.résidencePrincipale}
                                name="radio-buttons-group">
                                <FormControlLabel
                                    value="Zone urbaine"
                                    control={<Radio name='résidencePrincipale'
                                        onChange={(e) => handleChange(e)} />}
                                    label="Zone urbaine" />
                                <FormControlLabel
                                    value="Zone rurale"
                                    control={<Radio name='résidencePrincipale'
                                        onChange={(e) => handleChange(e)} />}
                                    label="Zone rurale" />
                                <FormControlLabel
                                    value="Sans objet"
                                    control={<Radio name='résidencePrincipale'
                                        onChange={(e) => handleChange(e)} />}
                                    label="Sans objet" />
                            </RadioGroup>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container direction='row' alignItems='center' justifyContent='center'>
                        <Grid item xs={12} md={7}>
                            <FormLabel component="legend">Un appartement ou une maison autre que ma résidence principale</FormLabel>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <RadioGroup
                                row
                                defaultValue={props.datas.typeApart && props.datas.typeApart.unNonPrincipale}
                                name="radio-buttons-group">
                                <FormControlLabel
                                    value="Zone urbaine"
                                    control={<Radio name='unNonPrincipale'
                                        onChange={(e) => handleChange(e)} />}
                                    label="Zone urbaine" />
                                <FormControlLabel
                                    value="Zone rurale"
                                    control={<Radio name='unNonPrincipale'
                                        onChange={(e) => handleChange(e)} />}
                                    label="Zone rurale" />
                                <FormControlLabel
                                    value="Sans objet"
                                    control={<Radio name='unNonPrincipale'
                                        onChange={(e) => handleChange(e)} />}
                                    label="Sans objet" />
                            </RadioGroup>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container direction='row' alignItems='center' justifyContent='center'>
                        <Grid item xs={12} md={7}>
                            <FormLabel component="legend">Plusieurs appartements ou maisons autres que ma résidence principale</FormLabel>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <RadioGroup
                                row
                                defaultValue={props.datas.typeApart && props.datas.typeApart.plusieursNonPrincipale}
                                name="radio-buttons-group">
                                <FormControlLabel
                                    value="Zone urbaine"
                                    control={<Radio name='plusieursNonPrincipale'
                                        onChange={(e) => handleChange(e)} />}
                                    label="Zone urbaine" />
                                <FormControlLabel
                                    value="Zone rurale"
                                    control={<Radio name='plusieursNonPrincipale'
                                        onChange={(e) => handleChange(e)} />}
                                    label="Zone rurale" />
                                <FormControlLabel
                                    value="Sans objet"
                                    control={<Radio name='plusieursNonPrincipale'
                                        onChange={(e) => handleChange(e)} />}
                                    label="Sans objet" />
                            </RadioGroup>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="outlined-multiline-static"
                        label="Autres : Veuillez préciser"
                        name='other'
                        multiline
                        rows={3}
                        sx={{width:'100%'}}
                        onChange={(e) => handleChange(e)}
                    />
                </Grid>
            </Grid>
            <ModalFooter buttons={buttons} />
        </>
    )
}